<template>
  <div
    class="main-background filter-page-container"
    :style="{ height: pageHeight + 'px' }"
  >
    <button type="button"
      class="filter-page-back-button"
      @click="$emit('setIsChangePage', 'home')"
    >
      <chevron-left-icon class="back-button-icon" />
      <p class="back-button-text">Повернутися до каталогу</p>
    </button>
    <div class="success-info-block">
      <check-icon class="check-icon" />
      <!-- <p class="success-info-text">{{ `Ваше замовлення №${getOrderId.id} було успішно сформовано.` }}</p> -->
      <p class="success-info-text">
        Перейдіть, будь ласка, до оплати замовлення для його оформлення.
      </p>
    </div>
    <div class="bottom-filter-button-container">
      <!-- <button class="filtration-button" @click="$emit('setIsChangePage', 'home')">
                Повернутися в каталог
            </button> -->
      <p v-if="paymentError" class="payment-error" role="alert">{{ paymentError }}</p>
      <p v-if="sending" role="status">Готуємо оплату…</p>
      <button class="return-to-shop" :disabled="sending || paymentState === 'uncertain'" @click="setReturnToChatBot">
        {{ sending ? 'Зачекайте…' : 'Перейти до оплати' }}
      </button>
      <button v-if="paymentError" class="return-to-shop" @click="returnToBot">Повернутися в бот</button>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon, CheckIcon } from "vue-feather-icons";
// import { GET_COME_TO_PAY } from '../helpers/requests'

export default {
  name: "is-success-page",
  components: {
    ChevronLeftIcon,
    CheckIcon,
  },
  props: {},
  data() {
    return {
      productCounter: 0,
      customerName: "",
      customerSecondName: "",
      customerPostNumber: "",
      onOrderNumber: "",
      customerCity: "",
      isWrongFormat: false,
      pageHeight: 0,
      sending: false,
      paymentError: "",
    };
  },
  async mounted() {
    console.log('Success page opened');
    window.scrollTo(0, 0);
    this.pageHeight = window.innerHeight - 150;
  },
  computed: {
    paymentState() { return this.$store.getters.paymentState; },
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
  },
  methods: {
    async setReturnToChatBot() {
      if (this.sending || this.paymentState === "uncertain") return;
      this.sending = true;
      this.paymentError = "";
      try {
        await this.$store.dispatch("setReturnToBot", this.getOrderId.id);
        this.returnToBot();
      } catch (error) {
        this.paymentError = "Не вдалося підтвердити перехід до оплати. Перевірте повідомлення в боті перед повторною дією.";
      } finally { this.sending = false; }
    },
    returnToBot() { window.Telegram.WebApp.close(); },
    setChangeCounter(value) {
      if (value === "+") {
        this.productCounter += 1;
      } else {
        this.productCounter -= 1;
      }
    },
    setCounterFinalPrice(array) {
      let price = 0;
      array.forEach((el) => {
        if (el.price) {
          price = price += el.price;
        }
      });
      return price;
    },
  },
  watch: {},
};
</script>

<style scoped>
.main-background {
  background: #fff;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
}
.filter-page-back-button {
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  padding: 18px;
  cursor: pointer;
}

.back-button-icon {
  position: absolute;
}

.back-button-text {
  text-align: center;
}

.filter-page-container {
  display: flex;
  flex-direction: column;
}

.bottom-filter-button-container {
  background: #fff;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  margin-top: auto;
}

.filtration-button {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}

.return-to-shop {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  color: #16abb8;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #16abb8;
}

.success-info-block {
  border-radius: 12px;
  border: 1px solid #d2d6db;
  background: #fff;
  margin: 30px auto 0 auto;
  width: 345px;
  padding: 12px 12px 50px 12px;
  display: flex;
  flex-direction: column;
}

.check-icon {
  width: 50px;
  height: 50px;
  color: #16abb8;
  margin: 0 auto;
}

.success-info-text {
  color: #333;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  max-width: 300px;
  margin: 0 auto;
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .main-background {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
  }

  .filter-page-back-button {
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 40px;
    border-bottom: 1px solid #f0f0f0;
  }

  .back-button-text {
    font-size: 20px;
    font-weight: 600;
  }

  .success-info-block {
    width: 600px;
    padding: 60px 50px;
    margin: 80px auto 0 auto;
    border-radius: 24px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
  }

  .check-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 32px;
  }

  .success-info-text {
    font-size: 24px;
    line-height: 36px;
    max-width: 500px;
    font-weight: 600;
  }

  .bottom-filter-button-container {
    max-width: 700px;
    margin: 60px auto 0 auto;
    padding: 30px 40px;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.1);
  }

  .return-to-shop {
    max-width: 500px;
    margin: 0 auto;
    font-size: 22px;
    font-weight: 700;
    padding: 20px;
    border-radius: 14px;
    transition: all 0.3s ease;
  }

  .return-to-shop:hover {
    background: #f0f9ff;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(22, 171, 184, 0.3);
  }
}
</style>

<style scoped>
.filter-page-back-button { width: 100%; background: #fff; border: 0; border-bottom: 1px solid #f0f0f0; cursor: pointer; color: #333; }
</style>
